<template>
    <div>
        <div class="box-ttl mb-3">
            {{ titleToDo }}
        </div>
        <div class="row" @change="prepareDataForSaving">
            <ValidationProvider
                class="col-md-6"
                name="Title"
                rules="required|min:2"
                v-slot="{ errors }"
            >
                <div class="form-group form-group-1">
                    <label for="" class="form-label">Title</label>
                    <input type="text" class="form-control" v-model="todo.title">
                    <FormError :error="errors[0]" name="Title"></FormError>
                </div>
            </ValidationProvider>

            <ValidationProvider
                class="col-md-6"
                name="Assign"
                rules="required"
                v-slot="{ errors }"
            >
                <div class="form-group form-group-1">
                    <label for="" class="form-label">Assign to</label>
                    <select class="custom-select"  v-model="todo.assigned_to">
                        <option value="selectOne" disabled>Select One</option>
                        <option
                            v-for="option in listOfUsers"
                            :value="option.id"
                        >
                            {{ option.name }} {{option.last_name}}
                        </option>
                    </select>

                    <FormError :error="errors[0]" name="Assign"></FormError>
                </div>
            </ValidationProvider>

            <ValidationProvider
                class="col-md-12"
                name="Client"
                rules="required"
                v-slot="{ errors }"
            >
                <div class="form-group form-group-1">
                    <label for="" class="form-label">Sites/Clients</label>

                    <select class="custom-select"  v-model="todo.client">
                        <option value="selectOne" disabled>Select One</option>
                        <option
                            v-for="option in clientsList"
                            :value="option.id"
                        >
                            {{ option.name }}
                        </option>
                    </select>

                    <FormError :error="errors[0]" name="Client"></FormError>
                </div>
            </ValidationProvider>

            <div class="col-12">
                <div class="center-separated-block">
                    <div class="half-block">
                        <div class="calendar-holder-wrap">
                            <label for="" class="form-label">
                                Start Date
                            </label>
                            <div class="calendar-holder">
                                <input
                                    type="date"
                                    class="form-control"
                                    v-model="todo.start_date"
                                >
                            </div>
                        </div>
                        <p
                            class="pb-0"
                            style="font-size: small; color: #dd3722"
                            v-if="errorValidationDate">
                            {{ errorMessage }}
                        </p>
                    </div>
                    <div class="half-block">
                        <div class="calendar-holder-wrap">
                            <label for="" class="form-label">
                                Deadline
                            </label>
                            <div class="calendar-holder">
                                <input
                                    type="date"
                                    class="form-control"
                                    v-model="todo.dead_line"
                                    :min="todo.start_date"
                                >
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <ValidationProvider
                class="col-md-12"
                name="Description"
                rules="required"
                v-slot="{ errors }"
            >
                <div class="form-group form-group-1">
                    <label for="" class="form-label">Description</label>
                    <textarea type="text" class="form-control" v-model="todo.description"></textarea>
                    <FormError :error="errors[0]" name="Description"></FormError>
                </div>

            </ValidationProvider>

            <ValidationProvider
                class="col-12"
                name="Priority"
                rules="required"
                v-slot="{ errors }"
            >
                <div class="d-flex">
                    <label for="" class="form-label mr-3">Priority</label>
                    <div class="form-group form-group-2 mr-3">
                        <div class="form-check">
                            <input
                                class="form-check-input-radio"
                                type="radio"
                                :name="`name1${index}`"
                                :id="`low${index}`"
                                v-model="todo.priority"
                                value="low"
                            >
                            <label class="form-check-label color--green" :id="`low${index}`">
                                <nobr> Low</nobr>
                            </label>
                        </div>
                    </div>
                    <div class="form-group form-group-2 mr-3">
                        <div class="form-check">
                            <input
                                class="form-check-input-radio"
                                type="radio"
                                :name="`name2${index}`"
                                :id="`medium${index}`"
                                :value="`medium`"
                                v-model="todo.priority"
                            >
                            <label class="form-check-label color--orange" :for="`medium${index}`">
                                <nobr>Medium</nobr>
                            </label>
                        </div>
                    </div>
                    <div class="form-group form-group-2 mr-3">
                        <div class="form-check">
                            <input
                                class="form-check-input-radio"
                                type="radio"
                                :name="`name3${index}`"
                                :id="`high${index}`"
                                :value="`high`"
                                v-model="todo.priority"
                            >
                            <label class="form-check-label color--red" :for="`high${index}`">
                                <nobr>High</nobr>
                            </label>
                        </div>
                    </div>
                    <FormError :error="errors[0]" name="Priority" class="ml-3"></FormError>
                </div>

            </ValidationProvider>
        </div>
    </div>

</template>

<script>
import CommonService from "../../../AppUser/resources/js/services/CommonService";
import VueMultiSelect from "../../../../../resources/js/plugins/VueMultiSelect.vue";

export default {
    name: 'ToDoForm',
    components: {VueMultiSelect},
    emits:['data-changed'],
    props: {
        isMain: {
            type: Boolean,
            default: true
        },
        index: {
            type: Number
        },
        todo: {
            type: Object
        }
    },
    data() {
        return {
            listOfUsers: [],
            clientsList: [],
            errorMessage:'The second number must exceed the first one',
            errorValidationDate: false,
        }
    },
    methods: {
        async getListOfActiveClients() {
            try {
                const {data: clients} = await CommonService.getActiveClients()
                this.clientsList = clients
            } catch (e) {
            }
        },
        async getListOfActiveUsers() {
            try {
                const {data: response} = await CommonService.getListOfActiveUsers()
                this.listOfUsers = response
            } catch (e) {
                console.error(e)
            }
        },

        prepareDataForSaving() {
            for (let key in this.todo) {
                if (!this.todo[key]) {
                    return false;
                }
            }
            this.$emit('data-changed', this.todo);
            return true
        }
    },
    mounted() {
        this.getListOfActiveClients();
        this.getListOfActiveUsers()

    },
    computed: {
        titleToDo() {
            if(this.isMain === true) {
                return 'Create Main To Do'
            } else {
                return 'Secondary Task'
            }

        }
    },


}

</script>


<style scoped>

</style>
